import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Heading, Text, Box } from '@wix/design-system';
import ExactMatch from '../../assets/images/exactMatch.svg';
import s from './TitleDisplay.module.scss';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { DomainText } from '../DomainText';
import { ComBrRestriction } from './ComBrRestriction';
import { useIsMobile } from '@wix/core-domain-search';
const MOBILE_MAX_WIDTH = '260px';
export const TitleDisplay = _ref => {
  let title = _ref.title,
    _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? false : _ref$primary,
    _ref$exactMatch = _ref.exactMatch,
    exactMatch = _ref$exactMatch === void 0 ? false : _ref$exactMatch,
    titleClassName = _ref.titleClassName,
    _ref$isLeanView = _ref.isLeanView,
    isLeanView = _ref$isLeanView === void 0 ? false : _ref$isLeanView,
    _ref$useCompactTitleS = _ref.useCompactTitleStyle,
    useCompactTitleStyle = _ref$useCompactTitleS === void 0 ? false : _ref$useCompactTitleS,
    _ref$showComBrRestric = _ref.showComBrRestriction,
    showComBrRestriction = _ref$showComBrRestric === void 0 ? false : _ref$showComBrRestric,
    _ref$overflowStrategy = _ref.overflowStrategy,
    overflowStrategy = _ref$overflowStrategy === void 0 ? 'ellipsis' : _ref$overflowStrategy,
    minFontSize = _ref.minFontSize,
    maxFontSize = _ref.maxFontSize;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  const titleClassNameSuffix = titleClassName ? ` ${titleClassName}` : '';
  const isMobile = useIsMobile();
  const overflowProps = {
    overflowStrategy,
    minFontSize,
    maxFontSize
  };
  if (exactMatch) {
    const exactMatchOptimizedClass = useCompactTitleStyle ? ` ${s.exactMatchTitleOptimized}` : '';
    const domainEllipsis = /*#__PURE__*/React.createElement(DomainText, _extends({}, overflowProps, {
      maxWidth: useCompactTitleStyle ? '100%' : isMobile ? MOBILE_MAX_WIDTH : '440px',
      textComponent: Heading,
      className: `${s.primaryTitle}${exactMatchOptimizedClass}${titleClassNameSuffix}`,
      textComponentProps: {
        as: 'span',
        size: 'large'
      }
    }), title);
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "7px"
    }, /*#__PURE__*/React.createElement(Box, {
      gap: "5px",
      align: "left",
      placeItems: "center",
      verticalAlign: "middle",
      className: s.exactMatch
    }, /*#__PURE__*/React.createElement(ExactMatch, {
      className: isMobile ? s.exactMatchIconMobile : s.exactMatchIcon
    }), useCompactTitleStyle ? domainEllipsis : /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "domains_search_gate.storefront_results.optimized.domain_available",
      values: {
        domainName: title
      },
      components: [domainEllipsis]
    }))), /*#__PURE__*/React.createElement(ComBrRestriction, {
      domainName: title
    }));
  }
  const maxWidth = isMobile ? MOBILE_MAX_WIDTH : '520px';
  if (primary) {
    const primaryTitle = /*#__PURE__*/React.createElement(DomainText, _extends({}, overflowProps, {
      maxWidth: maxWidth,
      textComponent: Heading,
      className: `${s.primaryTitle}${titleClassNameSuffix}`,
      textComponentProps: {
        size: 'large'
      }
    }), title);
    return showComBrRestriction ? /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "4px"
    }, primaryTitle, /*#__PURE__*/React.createElement(ComBrRestriction, {
      domainName: title
    })) : primaryTitle;
  }
  const regularTitle = /*#__PURE__*/React.createElement(DomainText, _extends({}, overflowProps, {
    maxWidth: maxWidth,
    className: `${useCompactTitleStyle ? s.regularTitleOptimized : isLeanView ? s.regularTitleLean : s.regularTitle}${titleClassNameSuffix}`
  }), title);
  return showComBrRestriction ? /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px"
  }, regularTitle, /*#__PURE__*/React.createElement(ComBrRestriction, {
    domainName: title
  })) : regularTitle;
};
//# sourceMappingURL=TitleDisplay.js.map